import { PageController } from '@client/components/_core/layout/PageController';
import { ClaimStatusEdit } from '@client/components/claims/ClaimStatusEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/console/$orgId/configuration/claims-products/claims/general/claim-statuses/edit/$claimStatusId',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Edit claim status',
        },
    },
    params: {
        parse({ claimStatusId }) {
            return {
                claimStatusId: BigInt(claimStatusId),
            };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <ClaimStatusEdit action={['edit', Route.useParams().claimStatusId]} />
        </PageController>
    );
}
